<template>
        <!--<div class="top">-->
            <!--<img src="@/assets/back.png" alt="" @click="back">-->
            <!--返回-->
        <!--</div>-->
        <!-- <div class="header">
            <div class="img">
                <img :src="folder.folderImgUrl" alt="">
            </div>
            <div class="name-num">
                <p>{{folder.folderName}}</p>
                <p>共<span>{{picList.length!=0?picList.length:0}}</span>张图片</p>
            </div>
        </div>
        <div class="content">
            <span v-for="(item,index) of picList" :id="'lipc'+index">
                <img :src="item.readCultureImg" alt="" @click="getPicDetails(item,index)">
            </span>
        </div> -->
        <!-- <img src="/static/img/fenxiang.png" class="fenxiang" @click="tofenxiang" v-show="isshowfenxiang"> -->
    
    <div>
    <!--<div class="top">-->
    <!--<img src="@/assets/back.png" alt="" @click="back">-->
    <!--返回-->
    <!--</div>-->
    <div class="header">
      <div class="img">
        <van-image
          width="2.06rem"
          height="2.06rem"
          fit="cover"
          :src="folder.folderImgUrl"
        />
      </div>
      <div class="name-num">
        <p>{{ folder.folderName }}</p>
        <p>
          共<span>{{ picList.length != 0 ? picList.length : 0 }}</span
          >张图片
        </p>
      </div>
    </div>
    <div class="content">
      <div class="content-img" v-for="(item, index) of picList" :id="'lipc' + index" :key="index" @click="getPicDetails(item, index)">
        <!-- <img
          :src="item.readCultureImg"
          alt=""
          @click="getPicDetails(item, index)"
        /> -->
        <van-image
          width="2.16rem"
          height="2.16rem"
          fit="cover"
          :src="item.readCultureImg"
          @click="getPicDetails(item, index)"
        />
      </div>
    </div>
    <img
      src="../assets/fenxiang.png"
      class="fenxiang"
      @click="tofenxiang"
      v-show="isshowfenxiang"
    />
  </div>

</template>

<script>
import { Toast } from 'vant';
export default {
    data () {
        return {
            folderId:'',
            picList:[],
            folder:'',
            index:0,
            isshowfenxiang:true,
        }
    },
    created () {
        this.folderId = this.$route.query.folderId
    },
    mounted () {
        this.getPicList()
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("android") > -1) {
            this.isshowfenxiang=true
        } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
            this.isshowfenxiang=true
        } else {
            this.isshowfenxiang=false
        }
    },
    methods:{
        back () {
            history.back(-1)
        },
    // 根据相册ID获取图片列表
        getPicList () {
            let that=this
            that.$axios.post('api/cultureFolder/listByCultureFolderId',{cultureFolderId:this.folderId}).then(res => {
                // console.log('3333',res.data.data)
                that.picList = res.data.data.cultures;
                that.folder = res.data.data.cultureFolder;
                that.checkwhlist ()
            })
        },
        checkwhlist () {
            let that=this
            setTimeout(function(){
                // for (var j=0;j<that.picList.length;j++) {
                //     if($('#lipc'+j+' img').width()>0 || $('#lipc'+j+' img').height()>0){
                //         if ($('#lipc'+j+' img').width()<$('#lipc'+j+' img').height()) {
                //             $('#lipc'+j+' img').css({'width':'auto','height':'1.84rem'})
                //         } else {
                //             $('#lipc'+j+' img').css({'width':'2.24rem','height':'auto'})
                //         }
                //     }
                // }
            },600);
        },
        // 跳转到图片详情页
        getPicDetails (item,index) {
            let that=this
            let tpurl=[],des=[],riqi=[],primaryCultureImg=[]
            for (let item of that.picList) {
                tpurl.push(item.readCultureImg?item.readCultureImg:'无')
                des.push(item.imgDescribe?item.imgDescribe:'无')
                let a=item.addTime?item.addTime.substr(0, 10):'无'
                riqi.push(a)
                primaryCultureImg.push(item.primaryCultureImg?item.primaryCultureImg:'无')
            }
            var userAgent = navigator.userAgent;
            try {
               if (userAgent.indexOf("android") > -1) {
                    window.Android.showGallery(tpurl,des,riqi,index);
                } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                    let datas=JSON.stringify({tpurl:tpurl,des:des,riqi:riqi,ind:index,primaryCultureImg:primaryCultureImg})
                    window.webkit.messageHandlers.showGallery.postMessage(datas);
                } else {
                    this.$router.push({
                        path:'/picDetails',
                        query:{
                            foldId:that.folder.cultureFolderId,
                            index:index,
                            picList:JSON.stringify(item),
                            // img:item.readCultureImg,
                            // details:item.imgDescribe,
                            // time:item.addTime,
                            // primaryCultureImg:item.addTime,
                        }
                    })
                } 
            } catch (error) {
                this.$router.push({
                        path:'/picDetails',
                        query:{
                            foldId:that.folder.cultureFolderId,
                            index:index,
                            picList:JSON.stringify(item),
                            // img:item.readCultureImg,
                            // details:item.imgDescribe,
                            // time:item.addTime,
                            // primaryCultureImg:item.addTime,
                        }
                    })
            }
            
        },
        tofenxiang(){
            // let picurl='https://ch.mglobal.atoshi.org/#/picList?folderId=' + this.folderId
            let picurl=window.location.origin + window.location.pathname + '/#/picList?folderId=' + this.folderId
            let _this=this
            var userAgent = navigator.userAgent;
            try {
                if (userAgent.indexOf("android") > -1) {
                    window.Android.shareNewsFromWebsite(_this.folder.folderName,picurl,_this.folder.folderImgUrl);
                } else if (/^.+(Mobile\/\w+)\s?$/.test(userAgent)) {
                    let datas=JSON.stringify({fxtitle:_this.folder.folderName,fxurl:picurl,fxcoverimg:_this.folder.folderImgUrl})
                    window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
                }
            } catch (error) {
                Toast("此应用暂不支持分享");
            }
            
        }
    },
}
</script>

<style scoped>
    .top{
        line-height: 1.3rem;
        height:1.3rem;
        background:#fff;
        color:#666666;
        font-size:.3rem;
        border-bottom:.12rem solid #F5F5F5;
    }
    .top img{
        margin-left:.3rem;
        vertical-align: middle;
        width:.3rem;
        height:.31rem;
    }
.header {
    margin-top:.45rem;
    margin-left:.3rem;
    height: 1.95rem;
    display: flex;
}
.img{
    width: 2.06rem;
  height: 2.06rem;
  /* background: url("/static/img/xiangCeBj.png")no-repeat; */
  /* background-size: 100%; */
  overflow: hidden;
  position: relative;

}
.img img{
      width: 1.95rem;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.name-num{
    margin-left:.33rem;
    position: relative;
}
.name-num p:first-of-type{
    width:4rem;
    position: absolute;
    font-size: .28rem;
    color:#333333;
    top:0;
}
    .name-num p:last-of-type{
        width:4rem;
        position: absolute;
        bottom: 0;
        font-size: .24rem;
        color:#999999;
    }
.name-num p:last-of-type span{
    font-size: .36rem;
    color:#00A0EA;
    padding:0 .1rem;
}
    .content{
        padding:0 .3rem;
        margin-top:.8rem;
        display: flex;
        flex-wrap: wrap;
    }
    .content .content-img{
  width: 2.16rem;
  height: 2.16rem;
  margin-right: .2rem;
  margin-bottom: .2rem;
}

.content .content-img:nth-child(3n){
  margin-right: 0;
}

    .content span{
        display: inline-block;
  overflow: hidden;
  margin-bottom: 0.08rem;
  margin-right: 0.08rem;
  width: 2.16rem;
  height: 2.16rem;
  position: relative;

    }
    .content span img{
        width:2.24rem;
        height:auto;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
    }
    .content span:nth-of-type(3n){
        margin-right:0;
    }
    .fenxiang{
        width:0.7rem;
        height:0.7rem;
        position: fixed;
        bottom:1.1rem;
        right:0.3rem;
        z-index: 1000;
    }
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/picList.vue